const CST = {
  REPLAY_HAS_W3MMD : 0x04,
  REPLAY_RATED : 0x08,
  REPLAY_LOCAL : 0x10,
  REPLAY_LADDER : 0x20,
  REPLAY_HAS_RESULTS : 0x40,
  REPLAY_HAS_MAP_PROFILE : 0x90
};

export default CST;